export default {"src":"/_next/static/media/picture.1348d82e.svg","height":56,"width":73,"blurWidth":0,"blurHeight":0};